import {Injectable} from '@angular/core';
import {tap} from 'rxjs/operators';
import {environment} from 'src/environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {CookieService} from 'ngx-cookie-service';
import {SharedService} from '../shared/shared-service';

@Injectable({
  providedIn: 'root'
})
export class OrganisationManagementService {

  constructor(public http: HttpClient, private sharedService: SharedService, private cookieService: CookieService) {

  }

  getAllOrgs(paginationData?: any) {
    return this.http.get(environment.serverLink + '/orgs/list?limit=' + paginationData.limit + '&skip=' + paginationData.skip, this.sharedService.generateHttpHeaders());
  }

  addOrEditOrg(data) {
    let request = null;
    if (data._id) {
      request = this.http.patch(environment.serverLink + '/orgs/update', data, this.sharedService.generateHttpHeaders());
    } else {
      request = this.http.post(environment.serverLink + '/orgs/add', data, this.sharedService.generateHttpHeaders());
    }
    return request.pipe(
      tap(
        (res) => {
          return data;
        },
        error => {
          return error;
        }));
  }

  getAllRegions(paginationData?: any, orgId?: string) {
    const link = environment.serverLink + '/regions/list?limit=' + paginationData.limit + '&skip=' + paginationData.skip;
    return this.http.post(link, {orgId}, this.sharedService.generateHttpHeaders());
  }

  addOrEditRegion(data) {
    let request = null;
    if (data._id) {
      request = this.http.patch(environment.serverLink + '/regions/update', data, this.sharedService.generateHttpHeaders());
    } else {
      request = this.http.post(environment.serverLink + '/regions/add', data, this.sharedService.generateHttpHeaders());
    }
    return request.pipe(
      tap(
        (res) => {
          return data;
        },
        error => {
          return error;
        }));
  }

  getAllState(paginationData?: any, regionId?: any) {
    return this.http.post(environment.serverLink + '/states/list?limit=' + paginationData.limit + '&skip=' + paginationData.skip, regionId, this.sharedService.generateHttpHeaders())
  }

  addOrEditState(data) {
    let request = null;
    if (data._id) {
      request = this.http.patch(environment.serverLink + '/states/update', data, this.sharedService.generateHttpHeaders());
    } else {
      request = this.http.post(environment.serverLink + '/states/add', data, this.sharedService.generateHttpHeaders());
    }
    return request.pipe(
      tap(
        (res) => {
          return data;
        },
        error => {
          return error;
        }));
  }

  getAllCity(paginationData?: any, stateId?: any) {
    return this.http.post(environment.serverLink + '/cities/list?limit=' + paginationData.limit + '&skip=' + paginationData.skip, {stateId}, this.sharedService.generateHttpHeaders());
  }

  addOrEditCity(data) {
    let request = null;
    if (data._id) {
      request = this.http.patch(environment.serverLink + '/cities/update', data, this.sharedService.generateHttpHeaders());
    } else {
      request = this.http.post(environment.serverLink + '/cities/add', data, this.sharedService.generateHttpHeaders());
    }
    return request.pipe(
      tap(
        (res) => {
          return data;
        },
        error => {
          return error;
        }));
  }

  getAllUsers(paginationData?: any) {
    return this.http.get(environment.serverLink + '/users/list?limit=' + paginationData.limit + '&skip=' + paginationData.skip, this.sharedService.generateHttpHeaders());
  }

  getUserInfo(user) {
    let userId = user;
    if (!user) {
      userId = this.sharedService.getUserDataFromSessionStorage()._id;
    }
    return this.http.get(environment.serverLink + '/users/info/' + userId, this.sharedService.generateHttpHeaders());
  }

  approveUser(userId, status) {
    return this.http.get(environment.serverLink + '/userApproval/' + userId + '/' + status, this.sharedService.generateHttpHeaders());
  }

  addOrEditUser(data) {
    let request = null;
    if (data._id) {
      request = this.http.patch(environment.serverLink + '/users/update', data, this.sharedService.generateHttpHeaders());
    } else {
      request = this.http.post(environment.serverLink + '/users/add', data, this.sharedService.generateHttpHeaders());
    }
    return request.pipe(
      tap(
        (res) => {
          return res;
        },
        error => {
          return error;
        }));
  }

  uploadingProfileImage(data) {
    return this.http.post(environment.serverLink + '/users/uploadProfileImage', data, {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.cookieService.get('securityToken')
      })
    }).pipe(
      tap(
        (res) => {
          return res;
        },
        error => {
          return error;
        }));
  }
  getMFAStatus(): any {
    return this.http.get(environment.serverLink + '/orgs/mfa-status', this.sharedService.generateHttpHeaders());
  }

  // Toggle Organization MFA
  toggleMFA(enable: boolean): any {
    return this.http.put(environment.serverLink + '/orgs/toggle-mfa', { enable }, this.sharedService.generateHttpHeaders());
  }

}
